/**
 * Deal-tag helpers used by the marketplace UI.
 * All API calls in this file are Super-Admin only — non-super-admins should not
 * see any of the components that consume it.
 */
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export const listTags = (token) =>
  axios.get(`${API}/reporting/marketplace/tags`, {
    headers: { Authorization: `Bearer ${token}` },
  }).then((r) => r.data);

export const createTag = (token, name) =>
  axios.post(`${API}/reporting/marketplace/tags`, { name }, {
    headers: { Authorization: `Bearer ${token}` },
  }).then((r) => r.data);

export const renameTag = (token, tagId, name) =>
  axios.patch(`${API}/reporting/marketplace/tags/${tagId}`, { name }, {
    headers: { Authorization: `Bearer ${token}` },
  }).then((r) => r.data);

export const deleteTag = (token, tagId) =>
  axios.delete(`${API}/reporting/marketplace/tags/${tagId}`, {
    headers: { Authorization: `Bearer ${token}` },
  }).then((r) => r.data);

export const mergeTags = (token, sourceId, targetId) =>
  axios.post(`${API}/reporting/marketplace/tags/merge`,
    { source_tag_id: sourceId, target_tag_id: targetId },
    { headers: { Authorization: `Bearer ${token}` } }
  ).then((r) => r.data);

export const getDealTags = (token, dealId) =>
  axios.get(`${API}/reporting/marketplace/tags/deal/${encodeURIComponent(dealId)}`, {
    headers: { Authorization: `Bearer ${token}` },
  }).then((r) => r.data);

export const setDealTags = (token, dealId, tagIds) =>
  axios.put(`${API}/reporting/marketplace/tags/deal/${encodeURIComponent(dealId)}`,
    { tag_ids: tagIds },
    { headers: { Authorization: `Bearer ${token}` } }
  ).then((r) => r.data);

export const listTaggedDeals = (token, opts = {}) => {
  const params = {};
  if (opts.q) params.q = opts.q;
  if (opts.only_untagged) params.only_untagged = true;
  return axios.get(`${API}/reporting/marketplace/tags/deals`, {
    headers: { Authorization: `Bearer ${token}` },
    params,
  }).then((r) => r.data);
};

// Deterministic hue from tag id — keeps chip colors stable across renders.
export const tagHue = (tagId) => {
  if (!tagId) return 0;
  let h = 0;
  for (let i = 0; i < tagId.length; i++) h = (h * 31 + tagId.charCodeAt(i)) % 360;
  return h;
};

export const tagChipStyle = (tagId) => {
  const hue = tagHue(tagId);
  return {
    backgroundColor: `hsla(${hue}, 65%, 55%, 0.15)`,
    color: `hsl(${hue}, 75%, 70%)`,
    borderColor: `hsla(${hue}, 65%, 55%, 0.35)`,
  };
};
